import {Injectable, signal} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {catchError, map, Observable, shareReplay, throwError} from 'rxjs';
import {TipoObra} from '../models/tipo-obra';
import {environment} from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TipoObraService {
  private readonly apiUrl = environment.api.uri;
  private readonly tiposObra$: Observable<TipoObra[]>;
  readonly tipoObraIconMap = new Map<number, string>();

  private readonly _iconesCarregados = signal(false);
  readonly iconesCarregados = this._iconesCarregados.asReadonly();

  constructor(private readonly http: HttpClient) {
    this.tiposObra$ = this.fetchTiposObra();
    this.tiposObra$.subscribe();
  }

  buildPinIcon(idTipoObra?: number): HTMLElement {
    const icone = idTipoObra ? this.tipoObraIconMap.get(idTipoObra) : null;

    if (icone) {
      const container = document.createElement('div');
      container.className = 'custom-map-pin';
      const img = document.createElement('img');
      img.src = `assets/icones-tipo-obra/${icone}`;
      img.width = 36;
      img.height = 36;
      img.alt = '';
      container.appendChild(img);
      return container;
    }

    return new google.maps.marker.PinElement({
      background: '#E41B2E',
      glyphColor: '#ffffff',
      borderColor: '#b01020',
    });
  }

  getTiposObra(): Observable<TipoObra[]> {
    return this.tiposObra$;
  }

  private fetchTiposObra(): Observable<TipoObra[]> {
    return this.http
      .get<TipoObra[]>(`${this.apiUrl}tipo-obra/listar-tipo-obra`)
      .pipe(
        map((response: TipoObra[]) => {
          for (const tipo of response) {
            this.tipoObraIconMap.set(tipo.id, tipo.icone);
          }
          this._iconesCarregados.set(true);
          return response;
        }),
        shareReplay(1),
        catchError((error) => {
          console.error('Erro ao carregar tipos de obra:', error);
          return throwError(() => error);
        })
      );
  }
}
